import { FaSatellite } from "react-icons/fa";
import { calculateVisibilityEcef, getSatelliteEcefKm, sgp4ToLonLatAlt } from "./Orbital";
import { memo } from "react";
import { propagate, SatRec } from "satellite.js";

export interface SatelliteEntryProps {
    satId:   number; //norad catId
    satName: string;
    now:     Date;
    rec:     SatRec;
    target?: number[];
    epoch:   Date;
}

export function SatelliteEntry( { satId, satName, rec, target, now, epoch }: SatelliteEntryProps ) {
    const pv         = propagate( rec, now );
    const ecef       = getSatelliteEcefKm( rec, now );
    const vis        = target ? calculateVisibilityEcef( ecef, target[1], target[0] ) : undefined;
    const baseCls    = "d-flex flex-row align-items-center gap-2";
    const canSee     = vis?.canSee ?? false;
    const successCls = canSee ? "bg-success text-white" : "";
    return <div className={`border rounded shadow m-2 p-2 ${successCls}`}>
        <div className={`${baseCls}`}>
            <FaSatellite /> {satName} ({satId})
        </div>
        {vis && <div className="small">
            <div>Distance:  {vis.range.toFixed( 2 )}</div>
            <div>Elevation: {vis.elevation.toFixed( 2 )}</div>
            <div>Epoch:     {epoch.toISOString()}</div>
        </div>}
    </div>;
}

export const MemoSatelliteEntry = memo( SatelliteEntry );
